var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-help",on:{"click":function($event){return _vm.openInfo()}}},[_c('span',{staticClass:"ti-help-alt"})])}
var staticRenderFns = []

export { render, staticRenderFns }